
import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  CircularProgress,
  TextField,
  Checkbox,
  Grid,
  Box
} from '@mui/material';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import CustomModal from '../components/modal/CustomModal';
import AddPersonalitiesModal from "../components/forms/invitations/modals/AddPersonalitiesModal"

// hooks

import { useAxios } from '../context/AxiosHookContext';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Foto', alignRight: false },
  { id: 'name', label: 'Invitado', alignRight: false },
  { id: 'name', label: 'Saludo', alignRight: false },
  { id: 'name', label: 'Institución', alignRight: false },
  { id: 'name', label: 'Correo', alignRight: false },
  { id: 'name', label: 'Contacto', alignRight: false },
  { id: 'name', label: 'Tipo de invitación', alignRight: false },
  { id: 'name', label: 'Estado', alignCenter: true },
  { id: 'name', label: 'Confirmación de visita', alignRight: "center" }
];

// ----------------------------------------------------------------------

export default function InvitationsPage() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [openModaOrganizations, setOpenModalOrganizations] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const stateParams = location?.state || {};

  if (!stateParams.description) {
    navigate("/invitationsPage")
  }

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [invitationList, setinvitationList] = useState([])
  const [openModalEdit, setOpenModal] = useState(false);
  const [showPictureModal, setShowPictureModal] = useState(false)
  const [total, setTotal] = useState({})

  const INVITATIONS_RECORDS_API = `/invitations/record?invitationId=${stateParams._id}&page=${page}&limit=10&fullName=${filterName}`
  const axios = useAxios();



  const onClose = () => {
    setOpenModal(false);
    getInvitationsRecords();
  }

  const getInvitationsRecords = useCallback(async () => {
    try {
      setinvitationList([])
      setLoading(true);
      const { data } = await axios.get(INVITATIONS_RECORDS_API);
      setinvitationList(data.data.list);
      setTotalPages(data.data.total_pages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, INVITATIONS_RECORDS_API, setinvitationList, setLoading]);


  const getTotals = useCallback(async () => {
    try {
      setinvitationList([])
      setLoading(true);
      const { data } = await axios.get(`/invitations/record/totals?invitationId=${stateParams._id}`);

      const sent = data?.data?.invitationStatus?.find(item=>item.invitationStatus === "sent") || {total: 0,invitationType: "sent"}
      const notSent = data?.data?.invitationStatus?.find(item=>item.invitationStatus === "notSent") || {total: 0,invitationType: "notSent"}
      const received = data?.data?.invitationStatus?.find(item=>item.invitationStatus === "received") || {total: 0,invitationType: "received"}

      const personal = data?.data?.invitationType?.find(item=>item.invitationType === "personal") || {total: 0,invitationType: "personal"}
      const mail = data?.data?.invitationType?.find(item=>item.invitationType === "mail") || {total: 0,invitationType: "mail"}

      const confirmedAssistance = data?.data?.confirmedAssistance?.find(item=>item.confirmedAssistance === true) || {total: 0,confirmedAssistance: true}
      
      const notConfirmed = {total: 0,confirmedAssistance: false };
      
      data?.data?.confirmedAssistance?.filter(item=>item.confirmedAssistance !== true).forEach(item=>{
        notConfirmed.total = item?.total + notConfirmed.total;
      })

      const object = {
        total: data.data?.count?.total || 0,
        invitationStatus: {
          sent,
          notSent,
          received
        },
        invitationType: {
          mail,
          personal
        },
        confirmedAssistance,
        notConfirmed

      }

      setTotal(object);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, setinvitationList, setLoading, stateParams]);


  const updateRecord = async (record, event) => {
    try {

      const { name, value } = event.target
      record[name] = value;

      await axios.put(`/invitations/record/update/${record._id}`, record);

      getInvitationsRecords();
      getTotals();
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getInvitationsRecords();
  }, [getInvitationsRecords, filterName])


  useEffect(()=>{
    getTotals();
  },[])

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  const onMouseEnter = () => {

  }


  const onMouseLeave = () => {

  }


  return (
    <>
      <Helmet>
        <title>{stateParams.description} | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          {stateParams.description}
        </Typography>
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setOpenModal(true)}>
          Invitados
        </Button>
      </Stack>

      <Stack >
        <Grid container alignItems={"center"} p={2} justifyContent={"space-between"}>
          <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
                Invitados
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                  total?.total || 0
                }
              </Typography>

            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
                Confirmados
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                 total?.confirmedAssistance?.total || 0
                }
              </Typography>


            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
                No confirmados
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                  total?.notConfirmed?.total || 0
                }
              </Typography>

            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
                Inv. Enviada
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                    total?.invitationStatus?.sent?.total || 0
                }
              </Typography>

            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
              Inv. No enviada
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                  total?.invitationStatus?.notSent?.total || 0
                }
              </Typography>

            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box width={"100%"} textAlign={"center"} p={1} sx={{
              border: "1px solid #d4d1f1",
              borderRadius: 4,
              m: 1
            }}>

              <Typography variant="h4" gutterBottom>
              Inv. Recibida
              </Typography>

              <Typography variant="h6" gutterBottom>
                {
                  total?.invitationStatus?.received?.total || 0
                }
              </Typography>

            </Box>
          </Grid>
        </Grid>
      </Stack>

      <Card>

        <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              headLabel={TABLE_HEAD}
            />
            <TableBody>
              {invitationList?.map((row) =>

              (
                <TableRow hover key={row._id} tabIndex={-1} role="checkbox">

                  <TableCell component="th" scope="row" padding="normal">
                    <img src={row?.funcionario?.foto || "https://observicios.gob.do/back/api/funcionarios/6391/foto"} alt="foto-funcionario" style={{
                      objectFit: "contain",
                      height: 100,
                      width: 100,
                      borderRadius: "100%"
                    }}
                      onMouseEnter={onMouseEnter(row?.funcionario?.foto)}
                      onMouseLeave={onMouseLeave}
                    />
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.funcionario?.fullName || "N/A"}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.funcionario?.categoria || "N/A"}
                    </Typography>
                  </TableCell>


                  <TableCell component="th" scope="row" padding="normal" sx={{ maxWidth: 100 }}>
                    <Typography variant="subtitle2" >
                      {row?.funcionario?.institucion || "N/A"}
                    </Typography>
                  </TableCell>


                  <TableCell component="th" scope="row" padding="normal" sx={{ maxWidth: 170 }}>
                    <Typography variant="subtitle2" sx={{ wordBreak: "break-word" }}>
                      {row?.funcionario?.email || "N/A"}
                    </Typography>
                  </TableCell>


                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.funcionario?.telefono || "N/A"}
                    </Typography>
                  </TableCell>


                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>

                      <TextField select size="small" value={row.invitationType || ""} name="invitationType" fullWidth onChange={(e) => updateRecord(row, e)}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 200, // Altura máxima en píxeles
                                overflowY: "auto", // Habilitar desplazamiento vertical
                              },
                            },
                          }
                        }}
                      >

                        <MenuItem value={"mail"} >Electrónica</MenuItem>
                        <MenuItem value={"personal"} >Física</MenuItem>

                      </TextField>

                    </Typography>
                  </TableCell>



                  <TableCell component="th" scope="row" padding="normal">

                    <TextField select size="small" value={row.invitationStatus || ""} name="invitationStatus" fullWidth onChange={(e) => updateRecord(row, e)}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Altura máxima en píxeles
                              overflowY: "auto", // Habilitar desplazamiento vertical
                            },
                          },
                        }
                      }}
                    >

                      <MenuItem value={"sent"} >Enviada</MenuItem>
                      <MenuItem value={"received"} >Recibida</MenuItem>
                      <MenuItem value={"notSent"} >No Enviada</MenuItem>

                    </TextField>


                  </TableCell>


                  <TableCell component="th" scope="row" padding="normal" style={{ textAlign: "center" }}>
                    <Checkbox defaultChecked onChange={(e) => updateRecord(row, { target: { name: e.target.name, value: e.target.checked } })} name="confirmedAssistance" checked={row.confirmedAssistance || false} />
                  </TableCell>



                </TableRow>
              ))}

            </TableBody>

            {
              loading === true &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={15} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

            {
              (invitationList.length === 0 && loading === false) &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={15} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <Typography variant="h6" paragraph>
                        Sin resultados
                      </Typography>

                      <Typography variant="body2">
                        No se encontraron resultados para
                        <br /> Intente con otra búsqueda.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

          </Table>
        </TableContainer>

        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChangePage}

          sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
        />


      </Card>

      <AddPersonalitiesModal onClose={onClose} openModalEdit={openModalEdit} invitation={stateParams} />
    </>
  );
}
